import request from '@/utils/request';
const querystring = require('querystring')

//获取列表数据
export const fetchData = query => {
    var list = request({
        url: 'comMonthFinanceMember/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const fetchAllData = query => {
    var list = request({
        url: 'comMonthFinanceMember/getList.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

//启用-禁用
export const changeStatus = query => {
    var list = request({
        url: 'comMonthFinanceMember/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//添加渠道信息
export const saveForm = query => {
    var list = request({
        url: 'comMonthFinanceMember/insert.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDelete = query => {
    var list = request({
        url: 'comMonthFinanceMember/delete.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDeleteMore = query => {
    var list = request({
        url: 'comMonthFinanceMember/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handUpdateMore = query => {
    var list = request({
        url: 'comMonthFinanceMember/updateMore.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const changeForm = query => {
    var list = request({
        url: 'comMonthFinanceMember/update.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const fetchSelect = query => {
    var list = request({
        url: 'comMonthFinanceMember/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};



